import cookie from './cookie';

const device = {
  getPlatform(ua: string){
    if (ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
      return 'ios';
    }
    else if (ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1) {
      return 'android';
    }
    else
      return null;
  },
  isIos: () => !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
  isInSnack() {
    return /bulldog|kwai/i.test(navigator.userAgent);
  },
  isInOldSnack() {
    return (device.isIos() && cookie.getItem('kpn') !== 'KWAI_BULLDOG') || (device.isAndroid() && +(cookie.getItem('ver') || '') < 5.7);
  },
  isInUVideo() {
    return /uvideo/i.test(navigator.userAgent);
  },
  isAndroid: () => navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1,
  isAndroid4x: () => /Android 4\./i.test(navigator.userAgent),
  // 如果是安卓设备，ud存在且不为'0'时，认作已登陆
  isLogin: () => {
    const ud = cookie.getItem('ud');
    return (device.isIos() && (cookie.getItem('token') || (!!ud && ud !== '(null)'))) || (device.isAndroid() && !!ud && ud !== '0');
  },
  getAndroidVersion () {
    const androidUa = navigator.userAgent.toLowerCase();
    let version = null;
    if (androidUa.indexOf('android') > 0) {
      const reg = /android [\d._]+/gi;
      const v_info = navigator.userAgent.match(reg);
      version = (v_info + '').replace(/[^0-9|_.]/ig, '').replace(/_/ig, '.'); //得到版本号4.2.2
      version = parseInt(version.split('.')[0]);// 得到版本号第一位
    }
    return version;
  },
  getIOSVersion() {
    const match = navigator.userAgent.match(/OS (\d+)_(\d+)_?(\d+)?/);
    if (!this.isIos() || !match || match.length < 3) {
      return false;
    }
    const version = Number(match[1]) + 0.1 * Number(match[2]);
    if (version > 0) {
      return version;
    }
    return false;
  },
  supportUniversalLink() {
    return this.getIOSVersion() >= 9;
  },

  getAppver: () => cookie.getItem('appver') || '1.0.0',
  getUd: () => cookie.getItem('ud') || '',
};


export default device;
